import {register} from '@shopify/theme-sections';
import Flickity from 'flickity';

import 'flickity-imagesloaded';
import ProductCard from '../components/product-card';
import {updateOffscreenPanelVisibility} from '../utils/a11y';

export default register('product-recommendations', {
  onLoad() {
    const container = this.container;

    const loadProductRecommendationsIntoSection = async () => {
      const productId = container.dataset.productId;
      const limit = container.dataset.limit;
      const rootUrl = window.theme.locale && window.theme.locale.primary ? '' : window.theme.locale.rootUrl;
      const requestUrl = `${rootUrl}/recommendations/products?section_id=product-recommendations&limit=${limit}&product_id=${productId}`;

      const response = await fetch(requestUrl);
      if (!response.ok) return;
      const data = await response.text();
      const fragment = document.createRange().createContextualFragment(data);
      const responseMarkup = fragment?.querySelector('.product-recommendations__wrapper');
      if (!responseMarkup) return;
      if ('replaceChildren' in HTMLElement.prototype) {
        container.replaceChildren(responseMarkup);
      } else {
        container.childNodes.forEach((node) => node.remove());
        container.appendChild(responseMarkup);
      }

      const sliderContainer = container.querySelector('.product-recommendations__slider');
      const productCards = sliderContainer?.querySelectorAll('.product-card');
      const slides = sliderContainer.querySelectorAll('.slide');
      if (!productCards) return;
      productCards.forEach((product) => {
        ProductCard(product);
      });

      const slider = new Flickity(sliderContainer, {
        freeScroll: false,
        prevNextButtons: true,
        pageDots: true,
        cellAlign: 'left',
        watchCSS: true,
        contain: true,
        groupCells: true,
        arrowShape: 'm12.075 51.432 27.04 23.66L36.572 78 4 49.5 36.571 21l2.545 2.908-27.04 23.66H95.8v3.864H12.075Z',
        on: {
          ready() {
            updateOffscreenPanelVisibility(slides);
          },
          change() {
            updateOffscreenPanelVisibility(slides);
          },
        },
      });

      document.addEventListener('resizeRecommendationsSlider', () => {
        if (!slider) return;
        slider.resize();
      });
    };

    loadProductRecommendationsIntoSection();
  },
});
